import { useState } from "react";
import axios from "axios";

export const useOrderSample = (setItems, onSuccess) => {
    const [modalData, setModalData] = useState(null);

    const handleSamplesUnavailable = (fabricId, data) => {
        setModalData({
            title: data?.title ?? '',
            text: data?.text ?? '',
            imageUrl: data?.imageUrl ?? null,
        });
        setItems(prevItems => prevItems.map(item =>
            item.pkFabricID === Number(fabricId)
                ? { ...item, samplesUnavailable: true }
                : item
        ));
    };

    const orderSample = async (fabricId) => {
        try {
            const response = await axios.post('/api/shopping-cart/sample',
                JSON.stringify({ fabricId: fabricId }),
                {
                    headers: { "Content-Type": "application/json" },
                    validateStatus: (status) => status === 200 || status === 400
                }
            );

            if (response.status === 400) {
                handleSamplesUnavailable(fabricId, response.data);
                return;
            }

            if (response.status === 200) {
                await onSuccess(fabricId);
            }
        } catch (error) {
            const status = error?.response?.status;
            if (status === 400) {
                handleSamplesUnavailable(fabricId, error.response.data);
            } else {
                console.error('Error ordering sample:', error);
            }
        }
    };

    return { orderSample, modalData, setModalData };
};
